import useIsRtl from "@/hooks/useIsRtl";
import EmblaSlider from "../Embla-slider";
import { TSlideWidith } from "../Embla-slider/EmblaSliderContainer";
import { JSX } from "react";

interface Props {
  spacing: number;
  children: JSX.Element[];
  selectedIndex?: number;
  className?: string;
}

const TabsSlider: React.FC<Props> = ({
  spacing,
  children,
  selectedIndex = 0,
  className = "pop-up-scrollabll-tabs",
}) => {
  const isRtl = useIsRtl();
  const dir = isRtl ? "rtl" : "ltr";

  return (
    <>
      <div dir={dir} className={className}>
        <EmblaSlider selectedIndex={selectedIndex}>
          <EmblaSlider.EmblaSliderViewport>
            <EmblaSlider.EmblaSliderContainer
              gap={spacing}
              slides={[
                ...(children as Array<JSX.Element>)?.map((child) => ({
                  component: child,
                  width: "auto" as TSlideWidith,
                })),
              ]}
            />
          </EmblaSlider.EmblaSliderViewport>
        </EmblaSlider>
      </div>
    </>
  );
};
export default TabsSlider;
